<template>
    <v-app>
    <Drawer current_item="menu_staff"></Drawer>

    
      <v-dialog v-model="dialog_add_group" max-width="400">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{ $t('add_group') }}</v-card-title>
          <v-card-text>
            <div class="subtitle-2 mt-6" align="left"><b>{{ $t('group_name') }}</b></div>
            <v-text-field v-model="new_group_name" outlined class="mt-1"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="addGroup">{{ $t('form_submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-main class="ml-6 mr-6">

            <v-row align="end" justify="space-between">
            <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                {{ $t('Appointment_Group_Title') }}
                </v-col>
            <v-col cols="12" md="4" align="left">
                <v-select
                    :value="select_station"
                    @change="changeStation"
                    :items="select_station_items"
                    item-text="station_name"
                    item-value="station_code"
                    persistent-hint
                    return-object
                    single-line
                    outlined
                    dense
                ></v-select>
            </v-col>
            </v-row>

            <v-divider></v-divider>
            
            <div align="right" class="mt-4 mr-12">
              <v-btn v-if="permission.includes('CREATE_reservation_group_list')" tile color="success" @click="dialog_add_group = true">
                  <v-icon left>mdi-plus</v-icon>{{ $t('add_group') }}
              </v-btn>
            </div>

            <v-card
                class="mx-auto mt-4 mr-6"
                outlined
                elevation=8
            >
                <v-simple-table fixed-header align="left" >
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="text-left">#{{ $t('group_id') }}</th>
                        <th class="text-left">{{ $t('group_name') }}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="item in group_list" :key="item.group_id" :onclick="'document.location = \'' + station_code + '/' + item.group_id + '\';'">
                            <td><a :href=" station_code + '/' + item.group_id">{{ item.group_id }}</a></td>
                            <td><a :href=" station_code + '/' + item.group_id">{{ item.group_name }}</a></td>
                        </tr>
                    </tbody>
                    </template>
                </v-simple-table>
            </v-card>
        </v-main>
    </v-app>
</template>

<style>
table tr td a {
    display:block;
    width:100%;
    text-decoration:none;
    color:inherit;
}
table tr td a:link {
  color:inherit;
}
table tr td a:visited {
  color:inherit;
}
table tr:hover {
    cursor: pointer;
}

</style>

<script>
import Drawer from '@/components/Drawer.vue'

import Staff from '@/model/instance/Staff.js'
import config from '@/../config.js'
import axios from 'axios';

export default {
  components: {
    Drawer
  },
  data () {
    return {
      dialog_add_group : false
      ,new_group_name : ""
      ,select_station : {station_name:"",station_code:""}
      ,select_station_items : []
      ,group_list : []
      ,station_code : this.$route.params.station_code
      ,permission : []
    }
  },
  mounted : function () {

    this.$store.getters.getStationList
    .then(result=>{
      this.select_station_items = result
      this.select_station = result.filter(s=>this.$route.params.station_code==s.station_code)[0]
    }).catch(error => {
      this.$router.push({name:'Error',params:error}) 
    })

    var que = this.$store.commit('addLoading')
    this.permission = Staff.getPermission('AppointmentGroup',this.$route.params.station_code).then(permission=>{
        this.permission = permission
        this.$store.commit('finishLoading',que)
    })

    this.reload()

  },
  methods : {
    reload(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.manage.appointment.manage.get_grouplist,{station_code:this.$route.params.station_code},{headers: Staff.getTokenHeader()})
      .then(response => {
        this.$store.commit('finishLoading',que)
        this.group_list = response.data.grouplist
      })
      .catch(error => {
          this.$router.push({name:'Error',params:error}) 
      })
    },
    changeStation(station){
      document.location = station.station_code
    },
    addGroup(){
      this.dialog_add_group = false
      var que = this.$store.commit('addLoading')
      axios
      .post(
        config.api.url.manage.appointment.group.add_group
        ,{station_code:this.$route.params.station_code,group_name:this.new_group_name}
        ,{headers: Staff.getTokenHeader()}
      ).then(() => {
        this.$store.commit('finishLoading',que)
        this.new_group_name = ""
        this.reload()
      }).catch(error => {
        this.$router.push({ name: 'Error' ,params:error}) 
      })

    }
  }
}
</script>